 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		20: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		20: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"c943faba","1":"c9c6fe98","2":"cb1608f2","3":"e86dabf1f82ac2c59fb4d5abdd400de2847d8eef","4":"styles","5":"framework","6":"4e15dda4174b9ddde57540b375bc4eea0f04f651","7":"ec1189df","8":"fe17621d0f21aa2bcc09c9de070364a570c9b7bb","9":"a22cbe4e","10":"be030488b285d4027c8dbcf38288d2075e681e58","11":"00abfcd549d0fb0a1d4e3bd21401043278c165b2","12":"6278397b","13":"535d7b591283ecc5509eff20d6e02c7edda9f5c2","14":"878080e00ebdb3197cd56b3c831f6a154a0842f9","15":"36e33814583380e252ca8d46e579314fc129cdbb","16":"13158df56e9e632e7eb058c220770cf6ad2477af","17":"19ade490a51823679678472c8a89ba583caa1da7","18":"280b84d27acf858faa78dd6b2daf44c1e8ac905c","19":"ea88be26","22":"component---cache-caches-gatsby-plugin-offline-app-shell-js","23":"component---src-pages-404-js","24":"component---src-pages-search-results-js","25":"component---src-pages-shareasmile-js","26":"component---src-pages-supplies-js","27":"component---src-pages-supplies-terms-conditions-js","28":"component---src-pages-terms-conditions-js","29":"component---src-pages-thank-you-js","30":"component---src-pages-wisdom-application-js","31":"component---src-pages-wisdom-js","32":"component---src-pages-wisdom-step-1-js","33":"component---src-pages-wisdom-step-2-js","34":"component---src-pages-wisdom-terms-conditions-js","35":"component---src-templates-academicadvantage-js","36":"component---src-templates-anesthesia-options-js","37":"component---src-templates-community-js","38":"component---src-templates-contact-us-js","39":"component---src-templates-covid-19-js","40":"component---src-templates-dental-implants-faq-js","41":"component---src-templates-doctor-one-js","42":"component---src-templates-get-started-js","43":"component---src-templates-index-js","44":"component---src-templates-our-oral-surgery-practice-js","45":"component---src-templates-patient-instructions-js","46":"component---src-templates-patient-stories-js","47":"component---src-templates-privacy-policy-js","48":"component---src-templates-procedures-js","49":"component---src-templates-sands-js","50":"component---src-templates-single-community-js","51":"component---src-templates-single-instruction-js","52":"component---src-templates-single-page-without-videos-js","53":"component---src-templates-single-procedure-with-multiple-videos-js","54":"component---src-templates-single-procedure-with-one-video-js","55":"component---src-templates-single-procedure-without-videos-js","56":"component---src-templates-single-review-js","57":"component---src-templates-stopthevape-js","58":"component---src-templates-three-d-imaging-js","59":"component---src-templates-treatment-options-js","60":"component---src-templates-why-choose-js","61":"component---src-templates-wisdom-teeth-removal-faq-js","62":"component---src-templates-your-first-visit-js"}[chunkId]||chunkId) + "-" + {"0":"2d7d376997c039a534c1","1":"926cc1544ec3a628d551","2":"4d98e6a6535184298a5c","3":"381f5e9a8c17f2918cfe","4":"08bc34de4ea872a98d93","5":"9d4b3190fea0d1eb3994","6":"c7516c3eed9b25bc2e0b","7":"046e41299cbe531c6220","8":"3f702268d60a8f468f8e","9":"c50341fc676a313a70bd","10":"9e96a3e618f8a5572425","11":"1e3136f3f3438cb3b0f4","12":"ac7f618b0c0a7a8dc02f","13":"6911a4749969abda261d","14":"dfcdaa3ac6cd3be2842a","15":"6dee9ceff1de84e2acb6","16":"4515a9125c07ad609837","17":"5df8d08cedf3bc6407b7","18":"0c7ddc876cbaa77d78e8","19":"265ad09c7af72608350b","22":"40044bc71df27c39b93d","23":"ae6b80a0235900a3c4cf","24":"7681f472f73661587b9b","25":"95f1d0eebadb7792ad04","26":"20790de3c927437859d4","27":"4895ada42397f041dc10","28":"28fe34d93caa19d0a6fb","29":"5f44a4671ecf0d9587b2","30":"1fdf24f30cffcb38d5f2","31":"09b33b62a1206e3539fd","32":"cf44ab88b19eecb22971","33":"0cd72cdf71cf143d0310","34":"3dae78e9dc13810f1523","35":"77b5a1fb52feba718ea0","36":"cdf74b09a7644a0836f1","37":"d28c0996e2b1aa86c8f8","38":"eb25b21cc5defd8b29c7","39":"3e908ac62862792e32a2","40":"e0390ce72615ae3eb337","41":"3e68efe4fcc0c724eddf","42":"e450b9f435ebeeec956f","43":"955ef65ab155d4ec352f","44":"dd4fac391d7b20b2fa55","45":"6caeda76e9c99e4e0697","46":"619ddc302461c7bc9bc0","47":"67da87858e32f703df91","48":"bfff518e860a00e68861","49":"a7ecdea41dfad692869c","50":"c7ee36d76fd9723f2791","51":"1c638cd9a73385b4829d","52":"3e51b04afaf91011159e","53":"e07004410fc6e7f4ca8f","54":"aecc30ffc744fdd92e4c","55":"ebcf1cf140fac2ac6200","56":"2c20b5e24bc28b8d7070","57":"ab7b6e24187a8c6b9946","58":"c58059ac7509442d7b66","59":"10d83af32632597c8f83","60":"cb4eed1f90d8ff587fea","61":"b1fc2831769783e87f78","62":"4bf04bdae1f7717e8187"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"4":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"c943faba","1":"c9c6fe98","2":"cb1608f2","3":"e86dabf1f82ac2c59fb4d5abdd400de2847d8eef","4":"styles","5":"framework","6":"4e15dda4174b9ddde57540b375bc4eea0f04f651","7":"ec1189df","8":"fe17621d0f21aa2bcc09c9de070364a570c9b7bb","9":"a22cbe4e","10":"be030488b285d4027c8dbcf38288d2075e681e58","11":"00abfcd549d0fb0a1d4e3bd21401043278c165b2","12":"6278397b","13":"535d7b591283ecc5509eff20d6e02c7edda9f5c2","14":"878080e00ebdb3197cd56b3c831f6a154a0842f9","15":"36e33814583380e252ca8d46e579314fc129cdbb","16":"13158df56e9e632e7eb058c220770cf6ad2477af","17":"19ade490a51823679678472c8a89ba583caa1da7","18":"280b84d27acf858faa78dd6b2daf44c1e8ac905c","19":"ea88be26","22":"component---cache-caches-gatsby-plugin-offline-app-shell-js","23":"component---src-pages-404-js","24":"component---src-pages-search-results-js","25":"component---src-pages-shareasmile-js","26":"component---src-pages-supplies-js","27":"component---src-pages-supplies-terms-conditions-js","28":"component---src-pages-terms-conditions-js","29":"component---src-pages-thank-you-js","30":"component---src-pages-wisdom-application-js","31":"component---src-pages-wisdom-js","32":"component---src-pages-wisdom-step-1-js","33":"component---src-pages-wisdom-step-2-js","34":"component---src-pages-wisdom-terms-conditions-js","35":"component---src-templates-academicadvantage-js","36":"component---src-templates-anesthesia-options-js","37":"component---src-templates-community-js","38":"component---src-templates-contact-us-js","39":"component---src-templates-covid-19-js","40":"component---src-templates-dental-implants-faq-js","41":"component---src-templates-doctor-one-js","42":"component---src-templates-get-started-js","43":"component---src-templates-index-js","44":"component---src-templates-our-oral-surgery-practice-js","45":"component---src-templates-patient-instructions-js","46":"component---src-templates-patient-stories-js","47":"component---src-templates-privacy-policy-js","48":"component---src-templates-procedures-js","49":"component---src-templates-sands-js","50":"component---src-templates-single-community-js","51":"component---src-templates-single-instruction-js","52":"component---src-templates-single-page-without-videos-js","53":"component---src-templates-single-procedure-with-multiple-videos-js","54":"component---src-templates-single-procedure-with-one-video-js","55":"component---src-templates-single-procedure-without-videos-js","56":"component---src-templates-single-review-js","57":"component---src-templates-stopthevape-js","58":"component---src-templates-three-d-imaging-js","59":"component---src-templates-treatment-options-js","60":"component---src-templates-why-choose-js","61":"component---src-templates-wisdom-teeth-removal-faq-js","62":"component---src-templates-your-first-visit-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"db1aa8d4711728220ee4","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
